module.exports = __webpack_public_path__ + "static/image-04-a11e7d7d292e2e0675f7c8fe20f3c33e.jpg";